if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      abortController = undefined;
      onVariantChangeUnsubscriber = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];
      cartUpdateUnsubscriber = undefined;

      constructor() {
        super();
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get productId() {
        return this.getAttribute('data-product-id');
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get productForm() {
        return this.querySelector('form[is="product-form"]');
      }

      get quantityInput() {
        return this.querySelector('quantity-input input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();

        this.currentVariant = this.getSelectedVariant(this);
        if (this.currentVariant) {
          this.updateMedia(this.currentVariant);
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;
        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;
        const viewMode = this.dataset.viewMode || 'main-product';

        if(target.classList.contains("pack-size")){
          let packVariant = this.getSelectedVariant(this);
          const input = this.productForm.querySelector('input[name="id"]');
          input.value = packVariant.id ?? '';
          console.log(target.parentElement.querySelector(".selected-pack"), target.nextElementSibling)
          target.parentElement.querySelector(".selected-pack").textContent = target.nextElementSibling.textContent;
          const source = this.querySelector(`#price-${this.sectionId} .f-price-item.f-price-item--regular`);
          if(source){
            source.textContent = FoxTheme.Currency.formatMoney(packVariant.price, Shopify.money_format);
          }
          return;
        }
        
        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage, viewMode, target)
            : this.handleUpdateProductInfo(productUrl, viewMode, target),
        });
      }

      handleSwapProduct(productUrl, updateFullPage, viewMode, target) {
        return (html) => {
          const quickView = html.querySelector('#MainProduct-quick-view__content');
          if (quickView && viewMode === 'quick-view') {
            html = quickView.content.cloneNode(true);
          }
          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));

          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;
            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
            HTMLUpdateUtility.viewTransition(
              document.getElementById('shopify-section-sticky-atc-bar'),
              html.getElementById('shopify-section-sticky-atc-bar'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );

            if (!variant) {
              this.setUnavailable();
              return;
            }
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }

          this.currentVariant = variant;
        };
      }

      handleUpdateProductInfo(productUrl, viewMode) {
        return (html) => {
          const quickView = html.querySelector('#MainProduct-quick-view__content');
          if (quickView && viewMode === 'quick-view') {
            html = quickView.content.cloneNode(true);
          }
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateShareUrl(variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(variant);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku');
          updateSourceFromDestination('Inventory');
          updateSourceFromDestination('Badges');
          updateSourceFromDestination('PricePerItem');
          updateSourceFromDestination('Volume');

          this.updateQuantityRules(this.sectionId, this.productId, html);
          updateSourceFromDestination('QuantityRules');
          updateSourceFromDestination('VolumeNote');
          updateSourceFromDestination('QuantityForm');
          updateSourceFromDestination('Product-MediaGallery');

          HTMLUpdateUtility.viewTransition(
            document.querySelector(`#SizeChart-${this.sectionId}`),
            html.querySelector(`#SizeChart-${this.sectionId}`),
            this.preProcessHtmlCallbacks,
            this.postProcessHtmlCallbacks
          );

          /*
          const addButtonUpdated = html.getElementById(`ProductSubmitButton-${this.sectionId}`);
          this.toggleAddButton(
            addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
            FoxTheme.variantStrings.soldOut
          );
          */

          const stickyAtcBar = document.getElementById(`shopify-section-sticky-atc-bar`);
          if (stickyAtcBar) {
            stickyAtcBar.classList.remove('hidden');
          }

          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });

          document.dispatchEvent(
            new CustomEvent('variant:changed', {
              detail: {
                variant: variant,
              },
            })
          );
        };
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      getSelectedVariant(productInfoNode) {
        const packEl = productInfoNode.querySelector("input.pack-size:checked");
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        const selectedVariantJSON = !!selectedVariant ? JSON.parse(selectedVariant) : null;
        const selectedVariantRes = packEl ? selectedVariantJSON.find(v => v.id?.toString() == packEl.value?.toString()) : selectedVariantJSON;
        return selectedVariantRes;
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      updateURL(url, variantId) {
        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      updateVariantInputs(variantId) {
        document
          .querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`)
          .forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = variantId ?? '';
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
      }

      updateMedia(variant) {
        const productMedia = this.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);
        if (!productMedia) return; // Early return if productMedia is not found

        const setActiveMedia = () => {
          if (typeof productMedia.setActiveMedia === 'function') {
            productMedia.init();
            productMedia.setActiveMedia(variant);
            return true; // Indicate success
          }
          return false; // Indicate failure
        };

        if (!setActiveMedia()) {
          this.timer = setInterval(() => {
            if (setActiveMedia()) {
              clearInterval(this.timer);
            }
          }, 100);
        }
      }

      updateShareUrl(variantId) {
        if (!variantId) return;
        const shareButton = document.getElementById(`ProductShare-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${variantId}`);
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = this.decoded(text);
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = this.decoded(FoxTheme.variantStrings.addToCart);
        }

        if (!modifyClass) return;
      }

      decoded(text) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = text;
        const decoded = tempDiv.textContent;
        return decoded;
      }

      setUnavailable() {
        this.toggleAddButton(true, FoxTheme.variantStrings.unavailable);
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
        const sku = document.getElementById(`Sku-${this.dataset.section}`);
        const volumePricing = document.getElementById(`Volume-${this.dataset.section}`);
        const stickyAtcBar = document.getElementById(`shopify-section-sticky-atc-bar`);

        if (price) price.classList.add('hidden');
        if (inventory) inventory.classList.add('hidden');
        if (sku) sku.classList.add('hidden');
        if (volumePricing) volumePricing.classList.add('hidden');
        if (stickyAtcBar) stickyAtcBar.classList.add('hidden');
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.setQuantityBoundries();
        if (!this.hasAttribute('data-original-section')) {
          this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
            FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }

      setQuantityBoundries() {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityBoundries, {
          data: {
            sectionId: this.sectionId,
            productId: this.productId,
          },
        });
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.productIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart')?.classList.add('btn--loading');

        fetch(`${this.getAttribute('data-url')}?variant=${currentVariantId}&section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.sectionId, this.productId, parsedHTML);
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart')?.classList.remove('btn--loading');
          });
      }

      updateQuantityRules(sectionId, productId, parsedHTML) {
        if (!this.quantityInput) return;

        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityRules, {
          data: {
            sectionId,
            productId,
            parsedHTML,
          },
        });

        this.setQuantityBoundries();
      }
    }
  );
}


setTimeout(() => {
  window.omnisend = window.omnisend || [];

  console.log('window.omnisend', window.omnisend)
}, 1000*3);

document.addEventListener('click', function (event) {
  const btn = event.target.closest('button[omnisend-in-stock-notify-form]');
  if (!btn) return;
  window.omnisend = window.omnisend || [];
  window.omnisend.push(['openForm', '695aa0d92349264e70ff84ff']);
});



document.addEventListener("DOMContentLoaded", () => {
  const jdgmEl = document.querySelector(".jdgm-widget");

  if (!jdgmEl) return;


  const badgeHTML = `
    <div class="jdgm-verified-badge-header">
      <svg class="jdgm-verified-checkmark" viewBox="0 0 20 20">
        <path d="M1.14026 0C0.510511 0 0 0.510511 0 1.14026V18.8599C0 19.4896 0.510511 20.0001 1.14026 20.0001H18.8597C19.4895 20.0001 20 19.4896 20 18.8599V11.3685C20 11.008 19.5606 10.8315 19.3112 11.0918L15.3614 15.2135C13.6736 16.9747 11.912 17.8504 10.0763 17.8407C8.25519 17.8454 6.52568 17.0288 4.8878 15.391C3.14847 13.6516 2.23211 11.7644 2.13874 9.72917C2.06539 7.84992 2.79892 6.0381 4.33936 4.29371C4.5345 4.07273 4.86976 4.0698 5.07804 4.27808L8.5462 7.74623C8.75271 7.95274 8.75486 8.28861 8.57448 8.51907C7.73628 9.59004 7.70456 10.5129 8.47933 11.2877C9.26203 12.0704 10.1356 11.9585 11.1 10.9521L19.8888 1.78078C19.9602 1.70632 20 1.60716 20 1.50403V1.14026C20 0.510511 19.4895 0 18.8597 0H1.14026Z"></path>
      </svg>
      <span class="jdgm-verified-text">Verified</span>
    </div>
  `;

  function appendBadge() {
    const widget = jdgmEl.querySelector(".jm-average-rating-display");
    if(!widget){
      return;
    }
    // prevent duplicate append
    if (widget.querySelector(".jdgm-verified-checkmark")) return;

    widget.insertAdjacentHTML("beforeend", badgeHTML);
  }

  // run once in case widget already exists
  appendBadge();

  const observer = new MutationObserver(() => {
    appendBadge();
  });

  observer.observe(jdgmEl, {
    childList: true,
    subtree: true,
  });
});

// Sync the all_reviews_text badge (near price) with product-specific rating.
// #judgeme_product_reviews only exists on product pages, so this is naturally scoped.
document.addEventListener("DOMContentLoaded", () => {
  const reviewWidget = document.querySelector('#judgeme_product_reviews');
  if (!reviewWidget) return;

  const productId = reviewWidget.dataset.id;
  const productData = window.jdgm?.data?.reviewWidget?.[productId];
  if (!productData) return;

  const rating = productData.average_rating ?? productData.rating;
  const count = productData.number_of_reviews ?? productData.reviews_count;
  if (rating == null || count == null) return;

  let observer = null;

  function syncBadge() {
    const ratingSpan = document.querySelector('.jdgm-all-reviews-text .jdgm-all-reviews-rating');
    const textSpan = document.querySelector('.jdgm-all-reviews-text .jdgm-all-reviews-text__text');
    if (!ratingSpan || !textSpan) return;

    // Pause observer while updating to avoid triggering ourselves
    observer?.disconnect();

    ratingSpan.setAttribute('data-score', rating);
    textSpan.setAttribute('data-score', rating);
    textSpan.setAttribute('data-number-of-reviews', count);

    const scoreEl = ratingSpan.querySelector('.jdgm-all-reviews-rating__score');
    if (scoreEl) scoreEl.textContent = parseFloat(rating).toFixed(1);

    const container = document.querySelector('.jdgm-all-reviews-text');
    if (container) observer?.observe(container, { childList: true, subtree: true });
  }

  let attempts = 0;
  function trySync() {
    const container = document.querySelector('.jdgm-all-reviews-text');
    if (container) {
      observer = new MutationObserver(syncBadge);
      syncBadge();
    } else if (attempts++ < 10) {
      setTimeout(trySync, 300);
    }
  }
  trySync();
});